import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { FarmService } from '.';
import { environment } from '../../../environments/environment';
import { SM } from '../../../assets/data/enum/storeModel.enum';
import { CONNECTION_HUB_CONNECTION_STATUSES } from '../_models/connection-hub/connection-hub';
import { ConnectionHubService } from './connection-hub/connection-hub.service';

@Injectable()
export class ClaasService {
  private isoTaskManagementServiceUrl = environment.isoTaskManagementServiceUrl;

  constructor(
    private http: HttpClient,
    private farmService: FarmService,
    private connectionHubService: ConnectionHubService
  ) {}

  storeClaasAccountData(): Observable<any> {
    return this.http
      .get<any>(this.isoTaskManagementServiceUrl + 'iso/taskdata/set-auth-cookie', {
        withCredentials: true,
      })
      .pipe(map((response) => response));
  }

  exportClaasFields(): Observable<any> {
    return this.http
      .post(this.isoTaskManagementServiceUrl + 'iso/taskdata/export-farm-fields', null)
      .pipe(map((response) => console.log('export finished')));
  }

  importClaasFields(): Observable<any> {
    return this.http
      .post(this.isoTaskManagementServiceUrl + 'iso/taskdata/import-farm-fields', null)
      .pipe(map((response) => console.log('import finished')));
  }

  disconnectClaasAccount(): Observable<any> {
    return this.http
      .delete(this.isoTaskManagementServiceUrl + 'iso/taskdata/revoke-token?externalSource=CLAAS')
      .pipe(map((response) => console.log('disconnected')));
  }

  getClaasAccountStatus(): Observable<any> {
    return this.http.get<any>(this.isoTaskManagementServiceUrl + 'iso/taskdata/get-auth', {
      withCredentials: true,
    });
  }

  getEquipmentList(externalSource): Observable<any> {
    return this.http.get<any>(
      this.isoTaskManagementServiceUrl +
        'iso/taskdata/getEquipmentList?externalSource=' +
        externalSource,
      { withCredentials: true }
    );
  }

  // Connect the claas telematics provider
  async connectClaasTaskData() {
    try {
      const currentFarm = await firstValueFrom(this.farmService.getFarmMeFromLocalStore());
      window.open(
        `https://telemetry.xfarm.ag/oauth/authenticate/claas_oft?farmUUID=${currentFarm.agrirouterUUID}&callback=${encodeURI(environment.SSOfrontAppCallback)}`,
        '_self'
      );
    } catch (e) {
      console.error(e);
    }
  }

  // Connect the claas point data provider
  async connectClaasPointData() {
    try {
      const currentFarm = await firstValueFrom(this.farmService.getFarmMeFromLocalStore());
      window.open(
        `https://telemetry.xfarm.ag/oauth/authenticate/claas_point_data?farmUUID=${currentFarm.agrirouterUUID}&callback=${encodeURI(environment.SSOfrontAppCallback)}`,
        '_self'
      );
    } catch (e) {
      console.error(e);
    }
  }

  // get claas pointData status
  getClaasPointDataStatus(): Observable<boolean> {
    return this.connectionHubService.getProvidersStatus().pipe(
      map((providers) => {
        // Stop if no providers are found
        if (!providers || providers.length === 0) {
          return false;
        }
        // Getting the generic provider
        const claasProvider = providers.find((provider) =>
          provider.storeModel.includes(SM.SM_EQUIPMENT_TELEMETRY_CLAAS_CONNECT)
        );

        if (!claasProvider) {
          return false;
        }

        // Return the status of the provider
        return claasProvider.status === CONNECTION_HUB_CONNECTION_STATUSES.CONNECTED;
      })
    );
  }
}
